// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2ZrV-","detailsBorder":"styles_detailsBorder__59mMl"};